<template>
  <div class="mb_db learner_program_requirment">
    <div class="row">
      <div class="col-12">
        <template v-if="isSelectedProgramRendered">
          <template v-if="selectedProgram.programTitle">
            <div class="text-center prog-req">
              <div class="row">
                <div class="col-12 sub_hd_bar">
                  <div class="sub_hd_ic">
                    <div class="ic ic22-dashboard1"></div>
                  </div>
                  <div class="hd_txt prog_txt">
                    Academic Progress for {{selectedProgram.programTitle}}
                  </div>

                  <div class="hd_rgt_ic">
                    <template>
                      <div class="legend-popup legends_sec">
                        <div id="legendPopup4"></div>
                        <div class="btn_legends" aria-label="progress legend">
                            <div class="legends_container">
                              <div class="btn_legends" id="progressLegends4" title="Legend">
                                <span class="sq_1 yellow"></span>
                                <span class="sq_2 red"></span>
                                <span class="sq_3 green"></span>
                                <span class="sq_4 orange"></span>
                              </div>

                              <b-popover ref="legendModal6" target="progressLegends4" triggers="click focus" container="legendPopup4" placement="bottom" class="legend_popup_container">
                                <template slot="title">
                                  <div class="row">
                                    <div class="col-10 header-title">Legend</div>
                                    <div class="col-2">
                                      <b-btn class="btn_close" title="Close Legend Popup" @click="closeLegendPopup">
                                        <span class="ic-close"></span>
                                      </b-btn>
                                    </div>
                                  </div>
                                </template>
                                <div class="row">
                                  <div class="col-6 progress-section mt-2">
                                    <div class="legend-title">Progress</div>
                                    <div class="status_row"><span class="ic22-progress completed"></span> completed</div>
                                    <div class="status_row"><span class="ic22-progress in_progress"></span> in progress</div>
                                    <div class="status_row"><span class="ic22-progress failed"></span> needs improvement</div>
                                    <div class="status_row"><span class="ic22-progress not_started"></span> not started</div>
                                  </div>
                                  <div class="col-6 performance-section mt-2">
                                    <div class="legend-title">Performance</div>
                                    <div class="status_row"><span class="lg_blc gradeA"></span> 90% - 100% </div>
                                    <div class="status_row"><span class="lg_blc gradeB"></span> 80% - 89% </div>
                                    <div class="status_row"><span class="lg_blc gradeC"></span> 65% - 79% </div>
                                    <div class="status_row"><span class="lg_blc gradeD"></span> 40% - 64% </div>
                                    <div class="status_row"><span class="lg_blc gradeE"></span>  0% - 39% </div>
                                    <div class="status_row"><span class="lg_blc noGrade"></span>  N/A </div>
                                  </div>
                                </div>
                              </b-popover>
                            </div>
                          </div>
                        </div>
                      </template>

                  </div>

                </div>
              </div>

              <div class="row">
                <div class="col-12 program_status_select_bx">
                        <div class="progress-row" v-if="showCourseProgress()">
                          <div class="progress-bar-label ace_sec_txt" :aria-label="inprogressCourses + ' of ' + totalCourses + ' courses'"></div>
                          <b-progress :max="totalCourses">
                            <b-progress-bar :value="completedCourses" :title="completedCourses+' Completed'" class="prog_bar__completed">{{completedCourses}}</b-progress-bar>
                            <b-progress-bar :value="inprogressCourses"  :title="inprogressCourses+' in-progress'" class="prog_bar__in_progress">{{inprogressCourses}}</b-progress-bar>
                            <b-progress-bar :value="notStartedCourses"  :title="notStartedCourses+' Not Started'" class="prog_bar__not_started">{{notStartedCourses}}</b-progress-bar>
                          </b-progress>
                        </div>
                  <div class="progress-row" v-else>
                    <div class="progress-bar-label">{{childrenCompleteCount}} of {{childrenCount}} competencies</div>
                    <b-progress :max="childrenCount">
                      <b-progress-bar :value="childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
                    </b-progress>
                  </div>
                </div>
              </div>

              <div class="lnk_container prog_sec">
                <div>
                  <span class="float-left ml-2 mt-2">Score</span>
                  <span class="progress_block float-left" style="height: 35px; width: 70px; margin-left: 8px;">
                    <span class="state" :class="statusClass(score, hideScoreForStudent)" style="height: 35px; width: 70px;">
                      <template v-if="isScoreNotAvailable || hideScoreForStudent">
                        <span class="progress_val ace_sec_txt" style="font-size: 15px;">N/A</span>
                      </template>
                      <template v-else>
                        <span class="progress_val ace_sec_txt" style="font-size: 15px;">{{score}}%</span>
                      </template>
                    </span>
                  </span>
                </div>
                <div>
                  <a href="javascript://" @click="navigateToProgramStatus" style="line-height: 30px; margin-right: 10px; padding-top: 5px; float: right;">{{ showMyProgramStatusTabLabel() }}</a>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="text-center prog-req">
              <div class="row">
                <div class="col-12 sub_hd_bar">
                  <div class="sub_hd_ic">
                    <div class="ic ic-icon_program"></div>
                  </div>
                  <div class="hd_txt">
                    My Progress
                  </div>
                </div>
              </div>
              <div class="row crd_content">
                <div class="col-12">
                  <div class="row sec_row">
                    <div class="no_data">
                      Progress data not available.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="row">
            <div class="col-12 sub_hd">
              <div class="hd_ic">
                <div class="ic ic22-dashboard1"></div>
              </div>
              <div class="hd_txt">
                Academic Progress
              </div>
            </div>
          </div>
          <div class="text-center prog-req mt-2">
            <stretch></stretch>
          </div>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapState, mapActions } from 'vuex'
  import {Stretch} from 'vue-loading-spinner'
  import { PACKAGE } from '../../../package_constants'
  export default {
    name: 'learner-program-competency-progress',
    props: ['program'],
    components: {
      Stretch
    },
    data: () => {
      return {
        score: 0,
        childrenCount: 0,
        totalCourses : 0,
        completedCourses : 0,
        inprogressCourses : 0,
        notStartedCourses : 0,
        courses : [],
        hideScoreForStudent:false,
        childrenCompleteCount: 0,
        isScoreNotAvailable: true,
        progressSummaryCount: 0,
        planningStream: {},
        selectedProgram: {},
        isSelectedProgramRendered: false
      }
    },
    beforeMount () {
      this.$root.$on('reloadCompetencyProgress', (data) => {
        this.selectedProgram = data
        this.populateStreamStructure(data.programCode)
        this.isSelectedProgramRendered = true
        this.populateProgram(data)
      })
    },
    methods: {
      ...mapActions([
        'loadStreamWithStructure',
        'loadMicroCompetencyProgress',
        'loadCompetencyProgress',
        'loadProgramGuide',
        'loadStreamWithStructure',
        'loadStreamWithStructureSummary'
      ]),
      resetData () {
        this.score = 0
        this.childrenCount = 0
        this.childrenCompleteCount = 0
        this.progressSummaryCount = 0
        this.isScoreNotAvailable = true
        this.planningStream = {}
        this.totalCourses = 0
        this.completedCourses = 0
        this.inprogressCourses = 0
        this.notStartedCourses = 0
        this.courses = []

      },
      async populateProgram (data) {
          let currentProgram = await this.loadProgramGuide({
          cipCode: data.programCipCode,
          programGuideCode: data.programCode,
          type: data.programType,
          loadDataFromServer: true
        })
        this.hideScoreForStudent = currentProgram.hideScoreForStudent
      },
      closeLegendPopup () {
        this.$refs.legendModal6.$emit('close')
      },
      async populateStreamStructure (programCode) {
        this.resetData()
        let performance = 0
        let stream = await this.loadStreamWithStructure(programCode)
        let structure = stream.structure
        if (structure) {
          let children = JSON.parse(structure)
          if (children.length > 0 && children.length <2) {
            let childStructure = children[0].structure
            if (childStructure) {
              let cStructure = JSON.parse(childStructure)
              this.courses = _.sortBy(cStructure, 'order')
            }
          }else{
            let structure1 = JSON.parse(structure)
            this.courses = _.sortBy(structure1, 'order')
          }
        }

        let summaries = await this.loadStreamWithStructureSummary(programCode)
        for (let i = 0; i < summaries.length; i++) {
            let competencySummary =  summaries[i]
            competencySummary.uuid = programCode + '_' + competencySummary.uuid
            this.childrenCount += competencySummary.childrenCount
            this.childrenCompleteCount+= competencySummary.childrenCompleteCount
            if (competencySummary.performance && competencySummary.status>0) {
                  this.isScoreNotAvailable = false
                  performance += competencySummary.performance
                  this.progressSummaryCount+=1
            }
            if(competencySummary.status==1){
              this.inprogressCourses +=1
            }
            if(competencySummary.status==2){
              this.completedCourses +=1
            }

        }
        let catalogAndCourses = this.getTotalCourseCatalogs(this.courses)
        this.totalCourses = catalogAndCourses.length
        this.notStartedCourses = (this.totalCourses - (this.inprogressCourses+this.completedCourses))
        this.score = (performance / this.progressSummaryCount).toFixed(2)

/*
        this.planningStream = await this.loadStreamWithStructure(programCode)
        let structure = this.planningStream.structure
        if (structure) {
          let children = JSON.parse(structure)
          if (children.length > 0) {
            let childStructure = children[0].structure
            if (childStructure) {
              let children = JSON.parse(childStructure)
              let courses = _.filter(children, (child) => {
                return (child.entityType === 'deliverycontext')
              })
              for (let i = 0; i < courses.length; i++) {
                let course = courses[i]
                let courseId = course.originUuid
                let mcSummary = await this.loadMicroCompetencyProgress(courseId)
                this.childrenCount += mcSummary.childrenCount
                this.childrenCompleteCount += mcSummary.childrenCompleteCount
                let competencySummary = await this.loadCompetencyProgress(courseId)
                if ((competencySummary.status === 1) || (competencySummary.status === 2)) {
                  performance += competencySummary.performance
                  this.progressSummaryCount += 1
                }
              }
              this.score = (performance / this.progressSummaryCount).toFixed(2)
              setTimeout(() => {
                if (this.score >= 0.00) {
                  this.isScoreNotAvailable = false
                } else {
                  this.isScoreNotAvailable = true
                }
              }, 1000)
            }
          }
        }
*/
      },
      navigateToProgramStatus () {
        let routerParams = {
          cipCode: this.selectedProgram.programCipCode,
          programGuideCode: this.selectedProgram.programCode,
          type: this.selectedProgram.programType,
          returnTo: 'learnerDashboard'
        }
        return this.$router.push({name: 'programGuideMyProgramStatus', params: routerParams})
      },
      showCourseProgress () {
        let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
        if (programDetail) {
          let flags = programDetail.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCourseProgress') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      getTotalCourseCatalogs(entities) {
        let courses = []

        entities.forEach((item, i) => {
           if (item.entityType === 'folder') {
             if (item.structure) {
               let structure = JSON.parse(item.structure)
               if (structure) {
                 let recursionEntities = _.sortBy(structure, 'order')
                 let response = []
                 response = this.getTotalCourseCatalogs(recursionEntities)
                 courses.push(...response)
               }
             }
           } else {
             courses.push(item)
           }

        })

        return courses
      },
      showMyProgramStatusTabLabel () {
        let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
          if (programDetail) {
            let flags = programDetail.flags
            for (var i = 0; i < flags.length; i++) {
              if (flags[i].title === 'showProgramProgress' && flags[i].label) {
                return flags[i].label
              }
            }
          }
        return 'My Progress'
      },
      statusClass (score, hideScoreForStudent) {
        if (score && !this.isScoreNotAvailable && !hideScoreForStudent) {
          if (score >= 90) {
            return 'gradeA'
          } else if (score >= 80 && score < 90) {
            return 'gradeB'
          } else if (score >= 65 && score < 80) {
            return 'gradeC'
          } else if (score >= 40 && score < 65) {
            return 'gradeD'
          } else if (score < 40) {
            return 'gradeE'
          }
        } else {
          return 'noGrade'
        }
      }
    },
    computed: {
      ...mapState({
      'enabledFeatures': state => state.dashboard.enabledFeatures,
        'learnerEnrollmentData': state => state.dashboard.learnerEnrollmentData
      })
    }
  }
</script>

<style scoped>
  .prog-req .card-header {
    height: 65px;
    padding-top: 0px;
  }

  .progress_block {
    float: right;
    margin-top: 1px;
    width: 50px;
    position: relative;
    text-align: center;
    height: 22px;
    background: #17b8ee;
    overflow: hidden;
  }

  .progress_block .state {
    float: left;
    height: 22px;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .progress_block .state .progress_val {
    font-size: 12px;
    color: #fff;
    display: block;
  }

  .gradeA {
    background: #008000;
  }

  .gradeB {
    background: #929000;
  }

  .gradeC {
    background: #eec635;
  }

  .gradeD {
    background: #ff8000;
  }

  .gradeE {
    background: #a01500;
  }

  .noGrade {
    background: #7d7d7d;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerProgramCompetencyProgress.vue